import * as React from 'react';

/**
 * @description Location icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Location } from '@sravni/design-system-icons'
 *
 * <Location />
 * ```
 */
const Location = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "Location", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M13.185 7.408a1.676 1.676 0 1 1-2.37 2.37 1.676 1.676 0 0 1 2.37-2.37", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M17.485 8.38a5.02 5.02 0 0 1-1.806 3.856l-1.799 1.499a5.018 5.018 0 0 0-1.548 2.269L12 17l-.332-.996a5.024 5.024 0 0 0-1.548-2.269l-1.799-1.499A5.017 5.017 0 0 1 6.515 8.38v.028C6.515 4.986 9.349 3 12 3c2.651 0 5.485 1.986 5.485 5.408", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M7 14.598c-2.409.627-4 1.69-4 2.902 0 1.933 4.029 3.5 9 3.5s9-1.567 9-3.5c0-1.212-1.591-2.276-4-2.902", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { Location };
//# sourceMappingURL=Location.js.map
